export default __webpack_public_path__ + "static/media/WrongInputBackground.0a3e68e2.webp";